/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_RenewInputs */

const id_tld_pricing_column_renew = /** @type {(inputs: Tld_Pricing_Column_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perpanjangan`)
};

const en_tld_pricing_column_renew = /** @type {(inputs: Tld_Pricing_Column_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renewal`)
};

/**
* | output |
* | --- |
* | "Renewal" |
*
* @param {Tld_Pricing_Column_RenewInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_renew = /** @type {((inputs?: Tld_Pricing_Column_RenewInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_RenewInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_renew(inputs)
	return id_tld_pricing_column_renew(inputs)
});